
import React from 'react';
import Calculators from '../components/Calculators';
import { User } from 'firebase/auth';

interface CalculatorsPageProps {
  currentUser: User | null;
}

const CalculatorsPage: React.FC<CalculatorsPageProps> = ({ currentUser }) => {
  return (
    <section>
      <Calculators currentUser={currentUser} />
    </section>
  );
};

export default CalculatorsPage;
